import * as actionType from "../redux-actions/actionTypes";

const initialState = {
  tables: {}, // Struktur: { tableNumber: { orders: [{ product, qty }] } }
};

const orderReducer = (state = initialState, action) => {
  const { tableNumber, Product, qty } = action; // Ambil `product` dari action

  switch (action.type) {
    case actionType.INC_ORDER: {
      const { tableNumber, Product } = action;
      const currentTable = state.tables[tableNumber] || { orders: [] };

      const existingProductIndex = currentTable.orders.findIndex(
        (order) => order.Product.id === Product.id
      );

      if (existingProductIndex >= 0) {
        const updatedOrders = [...currentTable.orders];
        updatedOrders[existingProductIndex].qty += 1;

        return {
          ...state,
          tables: {
            ...state.tables,
            [tableNumber]: {
              ...currentTable,
              orders: updatedOrders,
            },
          },
        };
      } else {
        return {
          ...state,
          tables: {
            ...state.tables,
            [tableNumber]: {
              ...currentTable,
              orders: [...currentTable.orders, { Product, qty: 1 }],
            },
          },
        };
      }
    }

    case actionType.DEC_ORDER: {
      const { tableNumber, Product } = action;
      const currentTable = state.tables[tableNumber] || { orders: [] };

      // Mencari indeks produk dalam pesanan
      const existingProductIndex = currentTable.orders.findIndex(
        (order) => order.Product.id === Product.id
      );

      if (existingProductIndex >= 0) {
        const updatedOrders = [...currentTable.orders];
        const currentQty = updatedOrders[existingProductIndex].qty;

        // Mengurangi qty jika lebih dari 1
        if (currentQty > 1) {
          updatedOrders[existingProductIndex].qty -= 1;
        } else {
          // Menghapus produk dari pesanan jika qty = 1
          updatedOrders.splice(existingProductIndex, 1);

          // Menghapus tabel jika tidak ada pesanan yang tersisa
          if (updatedOrders.length === 0) {
            const {
              [tableNumber]: removedTable,
              ...remainingTables
            } = state.tables;
            return {
              ...state,
              tables: remainingTables, // Hapus seluruh tabel jika tidak ada pesanan
            };
          }
        }

        // Memperbarui pesanan di tabel yang relevan
        return {
          ...state,
          tables: {
            ...state.tables,
            [tableNumber]: {
              ...currentTable,
              orders: updatedOrders,
            },
          },
        };
      }

      return state;
    }

    case actionType.UPDATE_ORDER: {
      const { tableNumber, ProductId, qty } = action;

      // Pastikan tabel dan pesanan sudah diinisialisasi
      const currentTable = state.tables[tableNumber] || { orders: [] };
      const existingProductIndex = currentTable.orders.findIndex(
        (order) => order.Product.id === ProductId
      );

      // Jika produk ditemukan dalam pesanan
      if (existingProductIndex >= 0) {
        const updatedOrders = [...currentTable.orders];

        if (qty > 0) {
          // Update qty jika qty > 0
          updatedOrders[existingProductIndex].qty = qty;
        } else {
          // Hapus produk jika qty <= 0
          updatedOrders.splice(existingProductIndex, 1);
        }

        // Jika tidak ada pesanan lagi, hapus tabel tersebut
        if (updatedOrders.length === 0) {
          const { [tableNumber]: removedTable, ...restOfTables } = state.tables;
          return {
            ...state,
            tables: restOfTables, // Hapus tabel jika tidak ada pesanan
          };
        }

        return {
          ...state,
          tables: {
            ...state.tables,
            [tableNumber]: {
              ...currentTable,
              orders: updatedOrders,
            },
          },
        };
      }

      // Jika produk tidak ditemukan dan qty > 0, tambahkan produk
      if (qty > 0) {
        return {
          ...state,
          tables: {
            ...state.tables,
            [tableNumber]: {
              ...currentTable,
              orders: [
                ...currentTable.orders,
                { Product: { id: ProductId }, qty }, // Tambahkan produk baru
              ],
            },
          },
        };
      }

      // Jika produk tidak ditemukan dan qty <= 0, tidak ada perubahan
      return state;
    }

    // Menghapus seluruh pesanan untuk meja tertentu
    case actionType.FLUSH_TABLE: {
      const { [tableNumber]: _, ...newTables } = state.tables;
      return {
        ...state,
        tables: newTables,
      };
    }

    // Menghapus semua pesanan untuk semua meja
    case actionType.FLUSH_ALL_ORDERS:
      return initialState;

    default:
      return state;
  }
};

export default orderReducer;
